<template>
    <div class="template-summary-cards">
        <slot>
            <!-- 기본 플레이스홀더 카드들 -->
            <div class="summary-card">
                <div class="card-label">요약 항목 1</div>
                <div class="card-value">값 1</div>
            </div>
            <div class="summary-card">
                <div class="card-label">요약 항목 2</div>
                <div class="card-value">값 2</div>
            </div>
            <div class="summary-card">
                <div class="card-label">요약 항목 3</div>
                <div class="card-value">값 3</div>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: "TemplateSummaryCards",
};
</script>

<style scoped>
.template-summary-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
}

.summary-card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
}

.card-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    margin-bottom: 8px;
}

.card-value {
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
}
</style>
